import { ExportToExcel } from '@/services/excel/generator/excelGenerator';
import ExportExcel from '@/services/excel/generator/exportExcel';
import SheetExcel from '@/services/excel/generator/sheetExcel';
import ColumnExcel from '@/services/excel/generator/columnExcel';

export const columns = [
  new ColumnExcel('Code client', 'tiersId', true),
  new ColumnExcel('Civilité', 'civilite', false, 255),
  new ColumnExcel('Nom', 'nom', true, 255),
  new ColumnExcel('Prénom', 'prenom', false, 255),
  new ColumnExcel('Fonction', 'fonction', false, 255),
  new ColumnExcel('Service ', 'service', false, 255),
  new ColumnExcel('Intitulé1', 'adresse.intitule1', false, 100),
  new ColumnExcel('Intitulé2', 'adresse.intitule2', false, 100),
  new ColumnExcel('Intitulé3', 'adresse.intitule3', false, 100),
  new ColumnExcel('Adresse1', 'adresse.adresse1', false, 100),
  new ColumnExcel('Adresse2', 'adresse.adresse2', false, 100),
  new ColumnExcel('Adresse3', 'adresse.adresse3', false, 100),
  new ColumnExcel('CP', 'adresse.codePostal', false, 100),
  new ColumnExcel('Ville', 'adresse.ville', false, 100),
  new ColumnExcel('Pays', 'adresse.pays', false, 100),
  new ColumnExcel('Latitude ', 'adresse.latitude', false, 100),
  new ColumnExcel('Longitude ', 'adresse.longitude ', false, 100),
  new ColumnExcel('Téléphone', 'telephone', false, 50),
  new ColumnExcel('Portable', 'portable', false, 50),
  new ColumnExcel('Email', 'email', false, 100),
  new ColumnExcel('Site Web ', 'siteWeb', false, 100),
  new ColumnExcel('Adresse contact différente', 'adresseContactDifferente'),
  new ColumnExcel('Agglomération ', 'adresse.agglomeration ', false, 100),
  new ColumnExcel('Département ', 'adresse.departement ', false, 100),
  new ColumnExcel('Code Insee ', 'adresse.codeInsee ', false, 50),
  new ColumnExcel('Type de contact', 'typesContactIds'),
  new ColumnExcel('Référence Externe', 'referenceExterne'),
];

export function templateConfig(data) {
  return new ExportExcel(
    'TemplateContact.xlsx',
    [
      new SheetExcel(
        'Contacts',
        columns,
        data,
        { skipHeader: false },
      ),
    ],
  );
}

export function generatedTemplateContact() {
  const exemple = {
    tiersId: 'C1994',
    nom: 'Contact C1994',
    adresseContactDifferente: 'NON',
    typesContactIds: '"Commercial","Signataire"',
  };
  const config = templateConfig([exemple]);
  ExportToExcel(config);
}
